import React, { ReactNode } from "react";
import "./SubscriptionPageWrapper.scss";

import AnimatedDiv from "src/app/components/AnimatedDiv/AnimatedDiv";
import classNames from "classnames";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as AngleLeftGrey } from "src/images/angle-left-grey.svg";

interface Props {
  children: ReactNode;
}

function SubscriptionPageWrapper(props: Props) {
  const { children } = props;

  return (
    <AnimatedDiv className="subscription-page-wrapper">{children}</AnimatedDiv>
  );
}

export default SubscriptionPageWrapper;

interface ContentProps extends Props {
  className?: string;
  width?: number;
  height?: number;
  backButtonFunction?: () => void;
  backButtonText?: string | ReactNode;
}

export function SubscriptionPageContent(props: ContentProps) {
  const {
    children,
    className,
    width,
    height,
    backButtonFunction,
    backButtonText,
  } = props;

  return (
    <AnimatedDiv
      className={classNames("subscription-page-content", className)}
      style={{ width, height }}
    >
      <div className="subscription-page-content__scroller">{children}</div>

      {backButtonFunction && (
        <div className="subscription-page-footer">
          <span
            className="subscription-page-footer__back"
            onClick={backButtonFunction}
          >
            <AngleLeftGrey className="trial-page-right__back-to-homepage-icon" />
            {backButtonText || (
              <IDHFormattedMessage id="ws_back" defaultMessage="Back" />
            )}
          </span>
          <div className="subscription-page-footer__copyrights">
            <IDHFormattedMessage
              id="ws_subscription_copyrights"
              defaultMessage="IDH Media Limited. All rights reserved © 2025"
            />
          </div>
        </div>
      )}
    </AnimatedDiv>
  );
}
